// @flow
import ColorPicker from './component';
import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        maxTemperature: ownProps.maxTemperature || getConfig(state, 'products:bulbs:maxTemperature'),
        minTemperature: ownProps.minTemperature || getConfig(state, 'products:bulbs:minTemperature')
    };
};

// $FlowFixMe
export default connect(mapStateToProps)(ColorPicker);



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/rgb-flipper/color-picker/index.js